// extracted by mini-css-extract-plugin
export default {"koruLogo":"KoruLogo_koruLogo__rZnb8"};